import { MemberViewModel } from 'presentation/screens/MembersScreen/MembersScreen.viewModel'
import { animationClasses } from 'presentation/utils/animationClasses'

export const memberStatusToAnimationClass = (memberStatus: MemberViewModel['status']) =>
  memberStatus === 'newly-enabled' || memberStatus === 'newly-added'
    ? animationClasses.jackInTheBox
    : memberStatus === 'newly-disabled' || memberStatus === 'initially-loaded'
      ? animationClasses.fadeIn
      : ''
